import ProjectServices from '../../services/booths/project';

export const state = {
    projects: [],
    project: {},
    statuses: [],
}

export const mutations = {
    setStatuses(state, statuses) {
        state.statuses = statuses
    },
    setProject(state, project) {
        state.project = project
    },
    setProjects(state, projects) {
        state.projects = projects
    }
}

export const getters = {
    getStatuses(state) {
        return state.statuses;
    },
    getProject(state) {
        return state.project;
    },
    getProjects(state) {
        return state.projects;
    },
}

export const actions = {
    statuses({commit}){
        return ProjectServices.getStatuses().then((response)=>{
            commit('setStatuses', response.data.data)
            return response
        })
    },
    get({commit}, id){
        return ProjectServices.get(id)
        .then((response)=>{
            commit('setProject', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return ProjectServices.getAll(data)
        .then((response)=>{
            commit('setProjects', response.data.data)
            return response
        })
    },
    delete({state, commit}, id){
        return ProjectServices.delete(id)
        .then((response)=>{
            commit('setProjects', state.projects.filter((x)=>x.id != id))
            return response
        })
    },
    updateStatus({state, commit}, data){
        return ProjectServices.updateStatus(data)
        .then((response)=>{
            commit('setProjects', state.projects.map((project)=>
                project.id == data.id ? response.data.data : project
            ))
            return response
        })
    },
}